export default {
  getList: "/api/DTODBA46/queryByPartNo",
  check: "/api/DTODBA46/queryByPartNoAndPopupCode",
  insert: "/api/DTODBA46/insert",
  updateAddress: "/api/DTODBA46/updateAddress",
  deletePopupCode: "/api/DTODBA46/deletePopupCode",
  updateIsread: "/api/DTODBA46/updateIsread",
  queryGuideCode: "/api/DTODBA46/queryGuideCode",
  insertGuideCode: "/api/DTODBA46/insertGuideCode",
  queryPopupCodeRecord:  "/api/DTODBA46/queryPopupCodeRecord",
  insertPopupCodeRecord: "/api/DTODBA46/insertPopupCodeRecord"
};
